

function getCookie(name) {
  const cookies = document.cookie.split('; ');
  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split('=');
    if (cookieName === name) {
      return cookieValue;
    }
  }
  return null;
}

async function supprimerTousLesCookies(nom) {
  var cookies = document.cookie.split(';');
  var nomTrim = nom.trim();
  for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf('=');
      var cookieNom = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
      
      if (cookieNom === nomTrim) {
          var chemins = location.pathname.split('/');
          var chemin = '';
          for (var j = 0; j < chemins.length; j++) {
              chemin += chemins[j] + '/';
              document.cookie = cookieNom + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT; path=' + chemin + '; domain=' + location.hostname + ';';
          }
      }
  }
}


function shouldShowPopup() {
  const lastShownDate = getCookie('welcome_modal_closed');
  if (!lastShownDate) {
    return true;
  }
  const currentDate = new Date();
  const lastShown = new Date(lastShownDate);
  // Calculate the time difference in milliseconds
  const timeDifference = currentDate - lastShown;

  // Convert the time difference to hours
  const hoursDifference = timeDifference / (1000 * 60 * 60);

  return hoursDifference > 24;
}

const modal = document.querySelector('#geoloc_modal');

modal.addEventListener('dialog:after-hide', () => {
  saveLastShownDate();
});


function saveLastShownDate() {
  const currentDate = new Date();
  // Calculate expiration date as 24 hours after the current date
  const expirationDate = new Date(currentDate.getTime() + 24 * 60 * 60 * 1000);
  document.cookie = `welcome_modal_closed=${currentDate.toISOString()}; expires=${expirationDate.toUTCString()}; path=/`;
}


let currentCountryUrl = '';
const countryMatrix = themeVariables.settings.countryMatrixMetaobject.country_selector_data_set;

var delete_cookie = function(name) {
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

const redirectionfunction = () => {
  delete_cookie('localization');
  saveLastShownDate();

  const countryData = countryMatrix.find((item) => item.ISOcode === currentCountryUrl);

  if (countryData) {
    const shop = countryData.external_language?.url || countryData.shop;
    if (shop) {
      location.href = shop;
    }
  } 
};

const current_country = document.querySelector('#current_country');


const showGeolocPopup = () => {
  fetch(`${window.Shopify.routes.root}browsing_context_suggestions.json`)
    .then((res) => res.json())
    .then((location) => {
      if (
        location.detected_values.country.handle != Shopify.country &&
        countryMatrix.some((item) => item.ISOcode == location.detected_values.country.handle) &&
        !Shopify.designMode
      ) {
        current_country.innerHTML = countryMatrix.find(
          (item) => item.ISOcode === location.detected_values.country.handle
        ).country;
        currentCountryUrl = location.detected_values.country.handle;
        modal.setAttribute('open', '');
      }
    });
}

function checkAndShowPopup() {
  const cookiesHandled = getCookie('OptanonAlertBoxClosed');
  if (cookiesHandled && shouldShowPopup()) {
    showGeolocPopup();
  }
}

function waitForOneTrust(maxAttempts = 10, attempt = 0) {
  if (typeof OneTrust !== 'undefined') {
    OneTrust.OnConsentChanged(() => checkAndShowPopup());
  } else if (attempt < maxAttempts) {
    setTimeout(() => waitForOneTrust(maxAttempts, attempt + 1), 500);
    console.error('OneTrust did not load in time.');
  }
}

async function updateGeolocModal() {
  try {
    // Détecter la langue du navigateur
    const browserLang = navigator.language || navigator.userLanguage;

    // Mapper les langues aux URL correspondantes
    const supportedLangs = {
      'fr': '/fr?section_id=geolocation-translate',
      'nl-NL': '/nl?section_id=geolocation-translate',
      'en-BE': '/en-be?section_id=geolocation-translate',
      'de-DE': '/de-de?section_id=geolocation-translate',
    };

    // Déterminer l'URL de redirection
    const redirectUrl = supportedLangs[browserLang] ||
      (browserLang.startsWith('fr') ? supportedLangs['fr'] :
      browserLang.startsWith('nl') ? supportedLangs['nl-NL'] :
        browserLang.startsWith('en') ? supportedLangs['en-BE'] :
          browserLang.startsWith('de') ? supportedLangs['de-DE'] :
            '/en-be?section_id=geolocation-translate');
    
    // Récupérer le contenu HTML de l'URL
    const response = await fetch(redirectUrl);
    supprimerTousLesCookies('localization');
    if (!response.ok) throw new Error(`Erreur HTTP : ${response.status}`);

    const productText = await response.text();

    // Extraire et mettre à jour le contenu du modal
    const parsedContent = new DOMParser().parseFromString(productText, 'text/html');
    const fetchedModalContent = parsedContent.querySelector(
      redirectUrl.includes('nl') ? '#nl-geoloc-translate' : '#geoloc-translate'
    );

    if (!fetchedModalContent) {
      console.error('Contenu de geoloc-translate introuvable dans la réponse.');
      return;
    }

    // Extraire le texte JSON du div #geoloc-translate
    const translateData = JSON.parse(fetchedModalContent.textContent);

    const modal = document.querySelector('#geoloc_modal');
    if (modal) {
      const currentCountry = countryMatrix.find((item) => item.ISOcode.toUpperCase() === Shopify.country);
      modal.querySelector('.h2').textContent = translateData.welcom.replace("{{country}}", currentCountry?.country);
      modal.querySelector('p:nth-of-type(2)').textContent = translateData.advice;
      const redirectionButtonText = modal.querySelector('.geoloc-buttons button p');
      if (redirectionButtonText) {
        const firstSpan = redirectionButtonText.querySelector('span');
        if (firstSpan) {
          firstSpan.textContent = translateData.redirection; 
        }
      }
      modal.querySelector('.geoloc-buttons button:nth-of-type(2) p').textContent = translateData.continue.replace("{{country}}", currentCountry?.country);;
    } else {
      console.error('Élément modal introuvable sur la page actuelle.');
    }


  } catch (error) {
    console.error('Erreur lors de la mise à jour du modal de géolocalisation :', error);
  }
}

if(shouldShowPopup()){
  updateGeolocModal();
  waitForOneTrust();
  checkAndShowPopup();
}
